import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  IRoleMain,
  MasterPages
} from "../../../commonFunctions/CommonFunctions";
import { getPermissions } from "../../../commonFunctions/PermissionManger";

import WSDataGridForDashboard, {
  IColumns
} from "../../../Components/DataGrid/WSDataGridForDashboard";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

import { IRows } from "../../../Components/Filter/WSFilterComponent";
import httpDashboard from "../../../commonFunctions/htttpClientNew";
import { HeaderList } from "../../../Components/Header/HeaderList";
export const ChequeIssuedList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  const [chequeIssuedlist, setChequeIssuedlist] = useState<any>([]);
  const [totalSum, setTotalSum] = useState<number>(0);

  const source = {
    url: "Bill/search",
    page: 1,
    pageSize: 10,
    filter: [
      {
        field: "ChequeIssued",
        operator: "eq",
        value: "true"
      }
    ],
    sort: []
  };

  // useEffect(() => {
  //   const getSummary = async () => {
  //     try {
  //       const response: any = await httpDashboard.get("Bill/payments-today");
  //       if (response) {
  //         // Add 'check' key for display
  //         response.forEach((item: any) => {
  //           item.check = item?.checkIssued ? "Yes" : "No";
  //         });

  //         // Filter for cheque-issued list
  //         const notIssueList: any = response.filter(
  //           (item: any) => item.checkIssued === true
  //         );
  //         setChequeIssuedlist(notIssueList || []);

  //         // Calculate total amount
  //         const total = response.reduce(
  //           (sum: number, item: any) => sum + Number(item.amount || 0),
  //           0
  //         );
  //         setTotalSum(total);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching bills:", error);
  //     }
  //   };
  //   getSummary();
  // }, []);

  useEffect(() => {
    const getBills = async () => {
      try {
        const response: any[] = await httpDashboard.get("Bill");

        if (response) {
          // 1️⃣  Add a display‑friendly flag
          const formatted = response.map((item) => ({
            ...item,
            check: item.chequeIssued ? "Yes" : "No" // ← use the real key
          }));

          // 2️⃣  Keep only the bills that actually had a cheque issued
          const issuedBills = formatted.filter((bill) => bill.chequeIssued);

          // 3️⃣  Expose that list if you still need it elsewhere
          setChequeIssuedlist(issuedBills);

          // 4️⃣  Sum just the issued bills’ amounts
          const total = issuedBills.reduce(
            (sum, bill) => sum + Number(bill.amount ?? 0),
            0
          );
          setTotalSum(total);
        }
      } catch (err) {
        console.error("Error fetching bills:", err);
      }
    };

    getBills();
  }, []);

  const columnsSummary: IColumns[] = [
    {
      fieldName: "supplierName",
      header: "Name"
    },
    {
      fieldName: "invoiceNo",
      header: "Invoice No",
      type: "default"
    },
    {
      fieldName: "paymentDate",
      header: "Payment Date",
      type: "date"
    },
    {
      fieldName: "amount",
      header: "Amount",
      type: "default"
    },
    {
      fieldName: "check",
      header: "IS CHEQUE ISSUED",
      type: "default"
    }
  ];

  const transFormData = (data: any[]) => {
    if (!data) return [];
    data.forEach((item) => {
      item.name = item?.supplier?.name;
    });
    return data;
  };

  const filterRows: IRows[] = [
    {
      label: "Due Date",
      fieldName: "dueDate",
      type: "date",
      operator: "lt"
    }
  ];

  const columns: IColumns[] = [
    { header: "Supplier Name", fieldName: "name", type: "default" },
    { header: "Invoice No", fieldName: "invoiceNo", type: "default" },
    {
      header: "Amount",
      fieldName: "amount",
      type: "currency"
    },
    { header: "Invoice Date", fieldName: "invoiceDate", type: "date" },
    { header: "Due Date", fieldName: "dueDate", type: "date" },
     {
      header: "Schedule Date",
      fieldName: "scheduledDate",
      type: "date"
    },
    { header: "Category", fieldName: "category", type: "default" }
  ];

  return (
    <>
      <Grid container spacing={2}>
        <HeaderList
          id="chequeIssued"
          title="Cheque Issued"
          info={`${totalSum || 0} Total Amount`}
          type="simple"
          usage="amount"
        />

        <Grid item xs={12}>
          {/* <WSDataGridForDashboard
            id="chequeIssueList"
            pageSize={10}
            columns={columnsSummary}
            data={chequeIssuedlist}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          /> */}

          <WSDataGridForDashboard
            id="checkIssueList"
            title="Check Issued"
            pageSize={10}
            searchBox={{ fieldName: "Category,InvoiceNo,Supplier.Name" }}
            filterFields={filterRows}
            columns={columns}
            source={source}
            transFormData={transFormData}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />
        </Grid>
      </Grid>
    </>
  );
});
